// eslint-disable-next-line id-match
import { PUBLIC_ROUTES } from 'constants/general';

import { ReactElement } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';

import { Portal } from '@treams/treams-ui';

import publicRoutes from 'packages/kakapo-ui-application/routers/publicRoutes';
import Login from 'packages/kakapo-ui-application/pages/auth/Login';
import HelpdeskContainer from '../../common/containers/HelpdeskContainer';
import ModalProvider from 'packages/kakapo-ui-kit/components/modals/ModalProvider';
import PopoverProvider from 'packages/kakapo-ui-kit/components/popovers/PopoverProvider';
import ModalNavigation from 'navigation/ModalNavigation';
import GoalRevision from 'goals/GoalRevision';
import * as graphql from 'generated/graphql';
import { useWorkspace } from 'packages/kakapo-ui-services/hooks/useWorkspace';
import { useTranslation } from 'react-i18next';
import { useWorkspaceLocale } from 'utility/hooks/useWorkspaceLocale';

const AppUnauthenticated = (): ReactElement => {
	const { i18n } = useTranslation();
	const location = useLocation();
	const params = new URLSearchParams(location.search);
	const workspace = useWorkspace();

	const availableLanguageQuery = graphql.useSupportedLanguagesInWorkspaceQuery({
		variables: {
			workspaceID: workspace.id,
		},
	});

	const availableLanguages = availableLanguageQuery.data?.workspace.supportedLanguageIDs ?? [];

	useWorkspaceLocale(availableLanguages, i18n.language);

	return (
		<>
			<HelpdeskContainer>
				<Portal.Provider fontFamily="Source Sans Pro">
					<ModalProvider>
						<PopoverProvider>
							<Switch>
								<Route path={PUBLIC_ROUTES.AUTHENTICATION} strict={false} exact={false}>
									<Login />
								</Route>
								{[...publicRoutes]}
								<Redirect
									to={{
										pathname: '/authentication',
										state: { originalTargetUrl: location.pathname },
									}}
								/>
							</Switch>
							<ModalNavigation url={params.get('modal') ?? ''}>
								<Switch>
									<Route path="/v2/goals/:id/revisions/:revision">
										{({ match }) => (
											<GoalRevision goalID={match!.params.id} revision={match!.params.revision} />
										)}
									</Route>
								</Switch>
							</ModalNavigation>
						</PopoverProvider>
					</ModalProvider>
				</Portal.Provider>
			</HelpdeskContainer>
		</>
	);
};

export default AppUnauthenticated;
